"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _PFM4PJSGcjs = require('./PFM4PJSG.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/popover/popover-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_PFM4PJSGcjs.DialogContextProvider],
  [_PFM4PJSGcjs.DialogScopedContextProvider]
);
var usePopoverContext = ctx.useContext;
var usePopoverScopedContext = ctx.useScopedContext;
var usePopoverProviderContext = ctx.useProviderContext;
var PopoverContextProvider = ctx.ContextProvider;
var PopoverScopedContextProvider = ctx.ScopedContextProvider;







exports.usePopoverContext = usePopoverContext; exports.usePopoverScopedContext = usePopoverScopedContext; exports.usePopoverProviderContext = usePopoverProviderContext; exports.PopoverContextProvider = PopoverContextProvider; exports.PopoverScopedContextProvider = PopoverScopedContextProvider;
